import clsx from 'clsx'
import React from 'react'
import styles from './TableMobileRow.module.css'
import colors from './TableCellColors.module.css'
import {
  TableRow
} from '@mui/material'

const TableMobileRowTitre = ({
  item,
  type,
  children
}) => {
  return (
    <TableRow
      className={
        clsx({
          [styles.titre]: true,
          [colors.ko]: (
            (item.status === 0) &&
            (type.groupe === 'demandes')
          ),
          [colors.ok]: (
            (item.status === 1) &&
            (type.groupe === 'demandes')
          )
        })
      }
    >
      {children}
    </TableRow>
  )
}

export default TableMobileRowTitre
